export default __webpack_public_path__ + "static/media/USDR&ELOGO.37ce19c9.png";